import {validate as validator} from "validate.js";

const rules = () => {
    return {
        name: {
            presence: true,
            length: {
                minimum: 2,
            }
        },
    }
};

const validate = (freightForwarder) => {
    return validator(freightForwarder, rules())
};

export default {validate};
